/**
 * Authentication constants
 */

// LocalStorage key for storing TTL
export const TTL_KEY = 'bff-app-ttl';

// LocalStorage key for storing last refresh check time
export const LAST_REFRESH_CHECK_KEY = 'bff-app-last-refresh-check';

// TTL threshold for auto-refresh (10 minutes in milliseconds)
export const TTL_REFRESH_THRESHOLD = 10 * 60 * 1000; // 10 minutes

// Interval to check for refresh (5 minutes in milliseconds)
export const REFRESH_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

// API endpoints (versioned as per BFF controller)
export const AUTH_ENDPOINTS = {
  LOGIN: '/v1/auth/login',
  LOGOUT: '/v1/auth/logout',
  REFRESH: '/v1/auth/refresh',
  PROFILE: '/v1/auth/profile',
} as const;
